import React, { useEffect, useState } from 'react';
import { EndStyles } from '../styles';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface LinkRedirectionTimerSectionProps {
  basicFlow?: boolean;
  redirectUrl?: string | null;
  content?: string;
  nextStepLabelColor: string;
  bannerImageEnabled: boolean;
  time: number;
}

const LinkRedirectionTimerSection = (props: LinkRedirectionTimerSectionProps): JSX.Element => {
  const { t } = useTranslation();
  const { basicFlow, nextStepLabelColor, redirectUrl, content, bannerImageEnabled, time } = props;
  const [counter, setCounter] = useState(time);
  const classes = EndStyles({ basicFlow, nextStepLabelColor, content });

  useEffect(() => {
    const timer: ReturnType<typeof setInterval> | false =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    if (timer) {
      return (): void => {
        clearInterval(timer);
        counter === 1 && redirectUrl && window.open(redirectUrl, '_self');
      };
    }
  }, [counter, redirectUrl]);

  return (
    <>
      {(content || bannerImageEnabled) && (
        <Grid item xs={12} className={classes.taskListLabelContainer}>
          <Typography variant="h1" className={basicFlow ? classes.basicDivider : classes.taskListLabel}></Typography>
        </Grid>
      )}
      <p className={classes.marginText}>{t('endAssessmentRedirectMsg', { counter })}</p>
    </>
  );
};

export default LinkRedirectionTimerSection;
